import { render, staticRenderFns } from "./outbound.vue?vue&type=template&id=20e44455&scoped=true&"
import script from "./outbound.vue?vue&type=script&lang=js&"
export * from "./outbound.vue?vue&type=script&lang=js&"
import style0 from "./outbound.vue?vue&type=style&index=0&id=20e44455&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e44455",
  null
  
)

export default component.exports